/**
 * Created by chenzheyu on 2017/6/16.
 */
import XKtypeTabs from './src/typeTabs.vue'

XKtypeTabs.install = function (Vue) {
  Vue.component(XKtypeTabs.name, XKtypeTabs)
}

export default XKtypeTabs



// WEBPACK FOOTER //
// ./src/components/module/typeTabs/index.js